import type { SupercontractTemplate } from '@paid-ui/types/supercontract';

import { contractManager } from '../model';

export const saveContractMetadata = (metadata?: SupercontractTemplate) => {
  contractManager.metadata = metadata ?? null;
};
